/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { Query } from '@apollo/client/react/components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { gql } from '@apollo/client';
import { object, string, shape } from 'prop-types';
import mbpLogger from '@module-logger/mbp';
import { compose } from 'recompose';

import { GRAPHQL_ENV } from '../../../../gql';
import * as app from '../../../../../state/ducks/App';
import RadioOffersResultBlock from './RadioOffersResultBlock';
import GraphqlSeoHeadTags from '../../GraphqlCommonComponents/GraphqlSeoHeadTags/GraphqlSeoHeadTags';

const brandSelectors = app.ducks.brand.selectors;
// TODO make the radio code dynamic
const RadioOfferResultsPage = ({ brand, page }) => {
    const code = page.path.split('/')[2];
    const RADIOPAGE_QUERY = gql`
            query RadioPageQuery {
                findRadioHost(brand: "${brand['domain-name']}", code:"${code}", environment: "${GRAPHQL_ENV}", locale: "en-us", productOptions: {page: 1, pageSize: 20, orderBy: BEST_SELLERS}) {
                    content
                    brand
                    mainCollection {
                        id
                        identifier
                        image
                        name
                        products {
                          id
                          isPassportEligible
                          image {
                              altText
                              name
                              snipe
                              path
                          }
                          partNumber
                          prices {
                              currency
                              type
                              value
                          }
                          skuPrices
                          skuPriceRange{
                              sale {
                                  value
                              }
                              retail{
                                  value
                              }
                          }
                          name
                          brand
                          seo {
                              url
                          }
                          availability {
                              deliveryMessage
                          }
                      }
                      }
                      featureCollection {
                        id
                        identifier
                        image
                        name
                        products {
                          id
                          isPassportEligible
                          image {
                              altText
                              name
                              snipe
                              path
                          }
                          partNumber
                          prices {
                              currency
                              type
                              value
                          }
                          skuPrices
                          skuPriceRange{
                              sale {
                                  value
                              }
                              retail{
                                  value
                              }
                          }
                          name
                          brand
                          seo {
                              url
                          }
                          availability {
                              deliveryMessage
                          }
                      }
                      }
                      listenerFavoritesCollection {
                        id
                        identifier
                        image
                        name
                        products {
                          id
                          isPassportEligible
                          image {
                              altText
                              name
                              snipe
                              path
                          }
                          partNumber
                          prices {
                              currency
                              type
                              value
                          }
                          skuPrices
                          skuPriceRange{
                              sale {
                                  value
                              }
                              retail{
                                  value
                              }
                          }
                          name
                          brand
                          seo {
                              url
                          }
                          availability {
                              deliveryMessage
                          }
                      }
                      }
                }
            }
        `;

    return (
        <Query query={RADIOPAGE_QUERY}>
            {({ loading, error, data }) => {
                if (loading) {
                    return null; // skeleton component
                }

                if (error) {
                    mbpLogger.logError({
                        appName: process.env.npm_package_name,
                        query: RADIOPAGE_QUERY,
                        component: 'RadioOfferResultsPage.js',
                        message: 'Error loading data from Graphql',
                        env: GRAPHQL_ENV,
                        error,
                    });
                    return null;
                }

                if (!data) {
                    mbpLogger.logWarning({
                        appName: process.env.npm_package_name,
                        query: RADIOPAGE_QUERY,
                        component: 'RadioOfferResultsPage.js',
                        message: 'No data returned for query',
                        env: GRAPHQL_ENV,
                    });
                    return null;
                }

                if (data?.findRadioHost?.content?.entries?.length > 0) {
                    const radioData =  data.findRadioHost.content.entries[0];
                    const seo = radioData.seo ?? {};
                    return (
                        <>
                            <GraphqlSeoHeadTags seoData={seo} />
                            <RadioOffersResultBlock
                                page={page}
                                data={radioData}
                                featureCollection={data.findRadioHost?.featureCollection}
                                listenerFavorites={data.findRadioHost?.listenerFavoritesCollection}
                                mainCollection={data.findRadioHost?.mainCollection}
                            />
                        </>
                    );
                }
                return 'No data returned for query';
            }}
        </Query>
    );
};

RadioOfferResultsPage.propTypes = {
    brand: object.isRequired,
    page: shape({
        path: string.isRequired,
    }).isRequired,
};

const mapStateToProps = (state) => ({
    brand: brandSelectors.getBrand(state),
});

const enhance = compose(
    withRouter,
    connect(mapStateToProps),
);

export default enhance(RadioOfferResultsPage);
